module.exports = __webpack_public_path__ + "media/invoice/loading-c301ab69.svg";